import React, { Component, SyntheticEvent, FocusEvent } from 'react';
import { inject, observer } from 'mobx-react';

import { Select as AntSelect } from 'antd';

type Option = {
	value: string,
	label: string,
};

type Props = {
	record: any,
	fieldValue?: number,
	field: string,
	options: Option[],
	onChange: Function,
};

@inject((stores, props: Props) => ({
	fieldValue: props.record[props.field],
}))
@observer
export default class Select extends Component<Props> {
	render() {
		const { fieldValue, onChange, options } = this.props;
		return (
			<AntSelect
				{...this.props}
				defaultValue={fieldValue}
				onChange={(value: any) => onChange(value)}
			>
				{options.map(option => <AntSelect.Option value={option.value}>{option.label}</AntSelect.Option>)}
			</AntSelect>
		);
	}
}
